import React, { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'

const MasterLayout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  /*
   * The tree is an instrument rather than an article: someone who taps "Pha do"
   * came for the diagram, and on a short screen the full banner hands them
   * 332px of decoration before the first ancestor -- 60% of a 553px phone
   * viewport. Only this route asks for the short banner; a phone gets a bar,
   * a short viewport elsewhere the compact banner, and `main` loses its top
   * padding under the bar; see `.site-header--compact` in index.scss.
   */
  const compactHeader = pathname.startsWith('/pha-do');
  
  return (
    /*
     * `clip`, not `hidden`. Both stop the pages that still carry a
     * `min-w-[800px]` from widening the document, but `overflow-x: hidden`
     * quietly turns this div into a scroll container, and a `position: sticky`
     * child anywhere below then pins itself to the top of *this* box -- which
     * is thousands of pixels above the screen -- instead of to the viewport.
     * That is what stopped the home page's cover column from following the
     * reader down. `clip` does the same clipping without the scroll container.
     */
    <div className='min-h-screen overflow-x-clip bg-yellow_FFFBEE'>
      <Header compact={compactHeader}/>
      <main className="w-full flex flex-col items-center justify-center pt-8 ">
        <section className="container-base">
          <Outlet />
        </section>
        <Footer />
      </main>
    </div>
  )
}

export default MasterLayout